import { Link } from "react-router-dom";

export function LogoMark({ className = "h-8 w-8" }) {
  return (
    <img src="/logo-mark.png" alt="" aria-hidden="true" width="32" height="32" className={`rounded-[9px] border border-white/15 bg-black object-contain ${className}`} />
  );
}

export function Logo({ to = "/", testId = "logo-link" }) {
  return (
    <Link to={to} data-testid={testId} className="group flex items-center gap-2.5" aria-label="Rivanta Labs home">
      <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[-8deg]" />
      <span className="text-[15px] font-semibold tracking-tight text-white">
        Rivanta<span className="font-serif italic font-normal text-cyan-300 text-[17px] ml-0.5">Labs</span>
      </span>
    </Link>
  );
}
